<template>
  <div id="product-page-footer">
    <WhyBuyFromArticle :with-divider="true" />
  </div>
</template>

<script>
import WhyBuyFromArticle from '../commons/WhyBuyFromArticle.vue';

export default {
  name: 'ProductPageFooter',
  components: {
    WhyBuyFromArticle,
  },
  data() {
    return {
      lastInter: '',
    };
  },
  methods: {
    onAccordionClick(alias) {
      const { mobileContent } = this.$refs;
      if (mobileContent) {
        if (this.lastInter && alias !== this.lastInter) {
          const activeContent = mobileContent.querySelector(`.accordion-content.${this.lastInter}.active`);
          if (activeContent) {
            activeContent.classList.remove('active');
          }
        }

        const targetContent = mobileContent.querySelector(`.accordion-content.${alias}`);
        if (targetContent) {
          const currentActive = targetContent.classList.contains('active');
          if (currentActive) {
            this.lastInter = '';
          } else {
            this.lastInter = alias;
          }
          targetContent.classList[currentActive ? 'remove' : 'add']('active');
        }
      }
    },
  },
};
</script>

<style lang="scss">

</style>
